<template>
    <main-content>
        <div v-if="is_current_user_fetched && $can('read', 'card-to-card-gateway')">
            <manage-gateways ></manage-gateways>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import {mapGetters} from 'vuex'
import ManageGateways from './components/manage-gateway.vue'

export default {
    components: {
        'main-content': mainContent,
        'manage-gateways': ManageGateways,
    },
    computed: {
        ...mapGetters('user', [
            'current_user', 'is_current_user_fetched'
        ]),
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
}
</script>

<style>

</style>